<template>
  <span
    class="label product-label label--new"
    v-text="`nieuw`"
  />
</template>

<style src="~layers/app/components/Product/Labels.css" />
